import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Status } from "../../enums/status";
import { CardContent, CardHeader } from "@mui/material";
import LoginContainer from "./LoginContainer";

export default function LoginLayout() {
  const [status, setStatus] = useState(Status.PENDING);
  const [message, setMessage] = useState("");

  return (
    <LoginContainer>
      <CardHeader title="Account Login" subheader={new Date().toDateString()}></CardHeader>
      <CardContent>
        <Outlet context={[status, setStatus, message, setMessage]} />
      </CardContent>
    </LoginContainer>
  );
}
